module.exports = __webpack_public_path__ + "static/img/computational-sciences-heading.6755df49.png";